import { readonly, ref, type Ref } from 'vue';

const STORAGE_KEY = 'dometry:sidebar';

type SidebarStorage = Pick<Storage, 'getItem' | 'setItem'>;

export interface SidebarState {
  /** Desktop only: the user collapsed the sidebar to the icon rail. */
  collapsed: Readonly<Ref<boolean>>;
  toggleCollapsed(): void;
  /** Phone only: the navigation drawer is open. */
  drawerOpen: Ref<boolean>;
}

export function createSidebar({
  storage = safeStorage(),
}: { storage?: SidebarStorage | null } = {}): SidebarState {
  const collapsed = ref(read(storage));
  const drawerOpen = ref(false);

  function toggleCollapsed(): void {
    collapsed.value = !collapsed.value;
    try {
      storage?.setItem(STORAGE_KEY, collapsed.value ? 'rail' : 'full');
    } catch {
      // Storage blocked: the choice still applies for this page view.
    }
  }

  return { collapsed: readonly(collapsed), toggleCollapsed, drawerOpen };
}

let shared: SidebarState | undefined;
export function useSidebar(): SidebarState {
  shared ??= createSidebar();
  return shared;
}

function read(storage: SidebarStorage | null): boolean {
  try {
    return storage?.getItem(STORAGE_KEY) === 'rail';
  } catch {
    return false;
  }
}

function safeStorage(): SidebarStorage | null {
  try {
    return globalThis.localStorage ?? null;
  } catch {
    return null;
  }
}
